import _cloneDeep from 'lodash.clonedeep';

export const cloneDeepObject = _cloneDeep;
